
import { IAuthenticationRequest } from "../../../model/security/request/authentication-request";
import { IPreAuthenticationRequest } from "../../../model/security/request/pre-authentication-request";
import { IAuthenticationResponse } from "../../../model/security/response/authentication-response";
import { IPreAuthenticationResponse } from "../../../model/security/response/pre-authentication-response";


export type LoginState = {
  step: number;
  preAuthenticationResponse?: IPreAuthenticationResponse;
  preAuthenticationRequest?: IPreAuthenticationRequest;
  authenticationRequest?: IAuthenticationRequest;
  authenticationResponse?: IAuthenticationResponse;
  fieldIsValid?: boolean;
  showPassword?: boolean;
  sucessLogin: boolean;
};

export enum ACTION_TYPES {
  setPreAuthenticationResponse = 'setPreAuthenticationResponse',
  setPreAuthenticationRequest = 'setPreAuthenticationRequest',
  setAuthenticationRequest = 'setAuthenticationRequest',
  setAuthenticationResponse = 'setAuthenticationResponse',
  setFieldIsValid = 'setFieldIsValid',
  setShowPassword = 'setShowPassword',
  setStep = 'setStep',
  setSucessLogin= 'setSucessLogin',
}

export const LoginReducer = (state: LoginState, action: any): LoginState => {
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPES.setPreAuthenticationResponse:
      return {
        ...state,
        preAuthenticationResponse: payload,
      };
    case ACTION_TYPES.setPreAuthenticationRequest:
      return {
        ...state,
        preAuthenticationRequest: payload,
      };
    case ACTION_TYPES.setAuthenticationRequest:
      return {
        ...state,
        authenticationRequest: payload,
      };
    case ACTION_TYPES.setAuthenticationResponse:
      return {
        ...state,
        authenticationResponse: payload,
      };
    case ACTION_TYPES.setFieldIsValid:
      return {
        ...state,
        fieldIsValid: payload,
      };
      case ACTION_TYPES.setSucessLogin:
        return {
          ...state,
          sucessLogin: payload,
        };
    case ACTION_TYPES.setStep:
      return {
        ...state,
        step: payload,
      };
    case ACTION_TYPES.setShowPassword:
      return {
        ...state,
        showPassword: payload,
      };
    default:
      throw new Error(`Unhandled action type: ${type}`);
  }
}